module.exports = __webpack_public_path__ + "img/02.dfdc1167.png";